import "./src/styles/global.css"
import "./src/styles/custom.css";
import React from "react";
import * as Sentry from "@sentry/gatsby";

// Initialise Sentry in the browser bundle.
// gatsby-browser.js is guaranteed to run client-side only.
Sentry.init({
  dsn: process.env.GATSBY_SENTRY_DSN || "https://9c53689a00f5e04fec34231456d1cf62@o4511030216228864.ingest.us.sentry.io/4511030290022400",
  environment: process.env.NODE_ENV || "production",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: false,
    }),
  ],
  // 100% of transactions locally, 10% in production
  tracesSampleRate: process.env.NODE_ENV === "production" ? 0.1 : 1.0,
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/strapi\.zusedigital\.com/,
    /^https:\/\/stagingstrapi\.zusedigital\.com/,
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enabled: true,
  ignoreErrors: [
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications",
    /^Script error\.$/,
    "Non-Error promise rejection captured",
    /^Validation failed on .* form$/,
    "ValidationError",
  ],
  beforeSend(event) {
    if (event.tags?.error_type === "validation") return null;
    const type = event.exception?.values?.[0]?.type;
    if (type === "ValidationError") return null;
    return event;
  },
  denyUrls: [
    /extensions\//i,
    /^chrome:\/\//i,
    /^chrome-extension:\/\//i,
    /safari-extension:/i,
  ],
  sendDefaultPii: true,
  enableLogs: true
});

// Wrap the entire app in Sentry's ErrorBoundary so any uncaught React
// render error is captured and a user-friendly fallback is shown.
export const wrapRootElement = ({ element }) => (
  <Sentry.ErrorBoundary
    fallback={
      <div style={{ padding: "2rem", textAlign: "center" }}>
        <p>Something went wrong. Our team has been notified.</p>
      </div>
    }
    showDialog={false}
  >
    {element}
  </Sentry.ErrorBoundary>
);

/*  export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  // Always scroll to the top on page navigation
  //console.log(location.action)
  //if (location.action === 'PUSH') {
    window.scrollTo(0, 0);
  //}

  return 
}
// gatsby-browser.js
export const onClientEntry = () => {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
}; */

// Using ES6 export syntax for Gatsby's browser API hooks
/* export const onRouteUpdate = () => {
  // Function to set the cursor style for all elements
  function setCursorStyle(style) {
    const elements = document.querySelectorAll("*");
    elements.forEach(element => {
      element.style.cursor = style;
    });
  }

  // Check if the custom cursor element exists
  const cursor = document.getElementById("customCursor");
  if (cursor) {
    // Adjust the custom cursor position on mouse movement
    document.addEventListener("mousemove", e => {
      cursor.style.left = `${e.pageX}px`;
      cursor.style.top = `${e.pageY}px`;
    });

    // Add or remove 'active' class on links hover
    const links = document.querySelectorAll("a");
    links.forEach(link => {
      link.addEventListener("mouseenter", () => cursor.classList.add("active"));
      link.addEventListener("mouseleave", () => cursor.classList.remove("active"));
    });

    // Hide the default cursor
    setCursorStyle("none");
  }
}; */

// gatsby-browser.js

/* export const onRouteUpdate = ({ location }) => {
  if (!location.hash) {
    window.scrollTo(0, 0);
  }
};

export const onInitialClientRender = () => {
  window.addEventListener('popstate', () => {
    window.scrollTo(0, 0);
  });
}; */



/* export const onRouteUpdate = ({ prevLocation }) => { // Check if this is not the initial page load
  if (prevLocation) { window.scrollTo(0, 0); } 
}; */

export const onRouteUpdate = ({ location }) => {
  if (!location.hash) {
    window.scrollTo(0, 0);
  }
  wrapCodeElements();
};

export const onInitialClientRender = () => {
  window.addEventListener('popstate', () => {
    window.scrollTo(0, 0);
  });
};

const wrapCodeElements = () => {
  document.querySelectorAll("code").forEach((codeEl) => {
    if (!codeEl.parentElement.classList.contains("blog-code-block-parent")) {
      const wrapper = document.createElement("div");
      wrapper.classList.add("blog-code-block-parent");

      codeEl.parentNode.insertBefore(wrapper, codeEl);
      wrapper.appendChild(codeEl);
    }
  });
};
 